/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useRef } from "react"
import "./layout.css"

const Layout:React.FC<{ children: any }> = ({ children }) => {
  return (
    <div className="relative">
      {/* <Header /> */}
      {children}
    </div>
  )
}

export default Layout
